// import React, { useEffect, useState, useMemo } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import { InputBox } from "../../components/Input";
// import "./Notificaions.css";
// import { API_URL } from "../../config";
// import axios from "axios";
// import StateManagedSelect from "react-select";
// import { showToast } from "../../components/toast";
// import LoadingSpinner from "../../components/LoadingSpinner";
// import { PermissionWrapper, hasPermission } from "../../helpers/permission.js";
// import usePersistedState from "../../Subscriber/usePersistedState.jsx";

// const Notifications = () => {
//   const navigate = useNavigate();
//   // Persisted filter states (like Order page)
//   const [serviceid, setServiceid] = usePersistedState(
//     "notifications_serviceid",
//     []
//   );
//   const [symbol_name, setSymbolName] = usePersistedState(
//     "notifications_symbol_name",
//     ""
//   );
//   const [status, setStatus] = usePersistedState("notifications_status", []);

//   const [notifications, setNotifications] = useState([]);
//   const [serviceOptions, setserviceOptions] = useState([]);
//   const [profitLoss, setProfitLoss] = useState([]);
//   const [editableIndex, setEditableIndex] = useState(null);
//   const [editedData, setEditedData] = useState({
//     target_price: "",
//     target2_price: "",
//     stoploss: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [filtersReset, setFiltersReset] = useState(false);
//   const [livePrices, setLivePrices] = useState({});
//   const token = localStorage.getItem("authToken");

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [pageCount, setPageCount] = useState(1);
//   const [total, setTotal] = useState(0);
//   const limit = 100;

//   // WebSocket connection for live price updates
//   useEffect(() => {
//     const ws = new WebSocket(process.env.REACT_APP_WS_URL);

//     ws.onopen = () => {
//       console.log("WebSocket connected");
//     };

//     ws.onmessage = (event) => {
//       try {
//         const messages = JSON.parse(event.data);
//         setLivePrices((prev) => ({
//           ...prev,
//           [messages.instrument_token]: messages.last_price,
//         }));
//         console.log("WebSocket message received:", messages);
//       } catch (error) {
//         console.error("Error parsing WebSocket message:", error);
//       }
//     };

//     ws.onerror = (error) => {
//       console.error("WebSocket error:", error);
//     };

//     ws.onclose = () => {
//       console.log("WebSocket connection closed");
//     };

//     return () => {
//       ws.close();
//     };
//   }, []);

//   // Update CMP prices when live prices change
//   useEffect(() => {
//     const updatedNotifications = notifications.map((notification) => {
//       const livePrice = livePrices[notification.instrument_token];
//       if (livePrice !== undefined) {
//         return {
//           ...notification,
//           cmp_price: livePrice,
//         };
//       }
//       return notification;
//     });

//     setNotifications(updatedNotifications);
//   }, [livePrices]);

//   // Calculate profit/loss in real-time
//   useEffect(() => {
//     const calculateProfitLoss = () => {
//       const newProfitLoss = notifications.map((notification) => {
//         const ep = parseFloat(notification.entry_price) || 0;
//         const cp = parseFloat(notification.cmp_price) || 0;
//         const qty = parseFloat(notification.quantity) || 0;
//         const buyact = parseInt(notification.action);
//         const status = parseInt(notification.status);
//         const gainsnew = parseFloat(notification.gains) || 0;

//         let profit = 0;

//         if (status === 1) {
//           // Only calculate for active notifications
//           if (buyact === 1) {
//             profit = (cp - ep) * qty;
//           } else if (buyact === 2) {
//             profit = (ep - cp) * qty;
//           }
//         } else {
//           // For non-active statuses (0, 2, 3, 4, 5, 6), use gainsnew from backend
//           profit = gainsnew;
//         }

//         return {
//           ...notification,
//           profit: profit.toFixed(2),
//         };
//       });

//       setProfitLoss(newProfitLoss);
//     };

//     calculateProfitLoss();

//     // Set up interval for continuous calculation (only affects active statuses)
//     const intervalId = setInterval(calculateProfitLoss, 1000);

//     return () => clearInterval(intervalId);
//   }, [notifications]);

//   const fetchServices = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${API_URL}service/active-services`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });
//       const formattedData = response.data.data.map((dt) => ({
//         value: dt.id,
//         label: dt.service_name,
//       }));

//       setserviceOptions(formattedData);
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchNotification = async () => {
//     let url = `${API_URL}notification/list?serviceid=${serviceid}&symbol=${symbol_name}`;
//     if (status && status.length > 0) {
//       // Join status array with commas and encode it
//       const encodedStatus = encodeURIComponent(status.join(","));
//       url += `&status=${encodedStatus}`;
//     }

//     try {
//       setLoading(true);
//       const response = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });
//       const notificationsData = response.data?.data?.data || [];
//       console.log("Fetched Notifications:", response);
//       setNotifications(notificationsData);
//       setTotal(notificationsData.length);
//       setPageCount(Math.ceil(notificationsData.length / limit));
//       setPage(1); // Reset to first page when data changes
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchNotification();
//     fetchServices();
//   }, []);

//   useEffect(() => {
//     const refreshed = sessionStorage.getItem("page_refreshed");
//     if (!refreshed) {
//       sessionStorage.setItem("page_refreshed", "true");
//       window.location.reload();
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "symbol_name") setSymbolName(value);
//   };

//   const handleSelectChange = (selectedOptions) => {
//     const selectedValues = selectedOptions
//       ? selectedOptions.map((option) => option.value)
//       : [];
//     setServiceid(selectedValues);
//   };

//   const handleSelectStatusChange = (selectedOptions) => {
//     const selectedValues = selectedOptions
//       ? selectedOptions.map((option) => option.value)
//       : [];
//     setStatus(selectedValues);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     fetchNotification();
//   };

//   const clearAll = () => {
//     setServiceid([]);
//     setSymbolName("");
//     setStatus([]);
//     try {
//       localStorage.removeItem("notifications_serviceid");
//       localStorage.removeItem("notifications_symbol_name");
//       localStorage.removeItem("notifications_status");
//     } catch (_) {}
//     setFiltersReset(true);
//   };

//   useEffect(() => {
//     if (filtersReset) {
//       fetchNotification();
//       setFiltersReset(false);
//     }
//   }, [filtersReset]);

//   const handleDelete = async (id) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You will not be able to recover this record!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonClass: "btn-danger",
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "No, cancel!",
//     });

//     if (result.isConfirmed) {
//       try {
//         setLoading(true);
//         const response = await axios.delete(
//           `${API_URL}notification/${id}/delete`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         setNotifications((prev) => prev.filter((dt) => dt.id !== id));
//         Swal.fire(
//           "Deleted!",
//           response.data.message || "Your record has been deleted.",
//           "success"
//         );
//         fetchNotification(); // Refresh data after deletion
//       } catch (error) {
//         Swal.fire(
//           "Error",
//           error.response?.data?.message ||
//             "Something went wrong while deleting.",
//           "error"
//         );
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const statusOptions = [
//     { value: "", label: "Select Status" },
//     { value: "0", label: "InActive" },
//     { value: "1", label: "Active" },
//     { value: "2", label: "Target 1" },
//     { value: "3", label: "Target 2" },
//     { value: "4", label: "Stoploss" },
//     { value: "5", label: "Closed" },
//   ];

//   const toggleEdit = (index) => {
//     setEditableIndex(index === editableIndex ? null : index);
//     const post = notifications[index];
//     setEditedData({
//       target_price: post.target_price || "",
//       target2_price: post.target2_price || "",
//       stoploss: post.stoploss || "",
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditedData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSave = async (id) => {
//     const payload = {
//       intgt1: parseInt(editedData.target_price),
//       intgt2: parseInt(editedData.target2_price),
//       insl: parseInt(editedData.stoploss),
//     };

//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${API_URL}notification/save-on-page?id=${id}&notifyme=true`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.success === true) {
//         setEditableIndex(null);
//         fetchNotification();
//         showToast.success("Notification updated successfully");
//       }
//     } catch (error) {
//       console.error("Error saving notification:", error);
//       showToast.error("There was an error saving the notification");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatusUpdate = async (e, id, status) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       const response = await axios.patch(
//         `${API_URL}notification/${id}/status?status=${status}`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         showToast.success("Notification Status Changed Successfully");
//         fetchNotification();
//       }
//     } catch (error) {
//       console.error("Error saving notification:", error);
//       showToast.error("There was an error saving the notification");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseNotification = async (e, id) => {
//     const { value: inputValue, isConfirmed } = await Swal.fire({
//       title: "Reason",
//       input: "text",
//       inputLabel: "Enter Reason For Closing?",
//       inputPlaceholder: "Enter Reason",
//       showCancelButton: true,
//       inputValidator: (value) => {
//         if (!value) {
//           return "You need to write something!";
//         }
//       },
//     });

//     if (isConfirmed && inputValue) {
//       try {
//         setLoading(true);
//         const response = await axios.put(
//           `${API_URL}notification/${id}/close`,
//           {
//             description: inputValue,
//           },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (response.status === 200) {
//           showToast.success("Notification Status Updated Successfully");
//           fetchNotification();
//         }
//       } catch (error) {
//         console.error("Error saving notification:", error);
//         showToast.error("There was an error saving the notification");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleUpdatePerformance = async (e, id) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       const response = await axios.patch(
//         `${API_URL}notification/${id}/performance`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         showToast.success("Notification Updated Successfully");
//         fetchNotification();
//       }
//     } catch (error) {
//       console.error("Error saving notification:", error);
//       showToast.error("There was an error saving the notification");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCommentUpdate = async (id) => {
//     const { value: inputValue, isConfirmed } = await Swal.fire({
//       title: "Comments",
//       input: "text",
//       inputLabel: "Enter Comments For User",
//       inputPlaceholder: "Enter Comments",
//       showCancelButton: true,
//       inputValidator: (value) => {
//         if (!value) {
//           return "You need to write something!";
//         }
//       },
//     });

//     if (isConfirmed && inputValue) {
//       try {
//         setLoading(true);
//         const response = await axios.post(
//           `${API_URL}notification/send-comment/${id}`,
//           {
//             commentDescription: inputValue,
//           },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         if (response.data.success == true) {
//           showToast.success("Comment Updated.");
//           fetchNotification();
//         }
//       } catch (error) {
//         showToast.error(
//           error.response?.data?.message ||
//             "Something went wrong while submitting."
//         );
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleGenerateResult = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       let params = [];
//       if (serviceid && serviceid.length) params.push(`serviceid=${serviceid}`);
//       if (symbol_name) params.push(`symbol=${symbol_name}`);
//       params.push(`status=${status.join(",")}`);

//       const queryString = params.length ? `?${params.join("&")}` : "";

//       const response = await axios.get(
//         `${API_URL}notification/generateResult${queryString}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           responseType: "blob",
//         }
//       );

//       if (response.status === 200) {
//         showToast.success("Performance Result Generated Successfully");
//       }
//     } catch (error) {
//       showToast.error(
//         error.response?.data?.message ||
//           "Something went wrong while downloading."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadResult = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       let params = [];
//       if (serviceid && serviceid.length) params.push(`serviceid=${serviceid}`);
//       if (symbol_name) params.push(`symbol=${symbol_name}`);
//       params.push(`status=${status.join(",")}`);
//       const queryString = params.length ? `?${params.join("&")}` : "";

//       const response = await axios.get(
//         `${API_URL}notification/resultLive${queryString}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           responseType: "blob",
//         }
//       );

//       if (response.status === 200) {
//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", "daily-result.png");
//         document.body.appendChild(link);
//         link.click();
//         link.remove();
//         window.URL.revokeObjectURL(url);
//         showToast.success("Result Downloaded Successfully");
//       }
//     } catch (error) {
//       showToast.error(
//         error.response?.data?.message ||
//           "Something went wrong while submitting."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleReactivation = async (e, id) => {
//     e.preventDefault();

//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You want to reactive this notification!",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Reactivate it!",
//       cancelButtonText: "No, cancel!",
//       confirmButtonClass: "btn-success",
//       cancelButtonClass: "btn-danger",
//     });

//     if (result.isConfirmed) {
//       await handleStatusUpdate(e, id, 1);
//     }
//   };

//   // Helper function to format profit/loss display
//   const formatProfitLoss = (profit) => {
//     const numProfit = parseFloat(profit);
//     if (numProfit >= 0) {
//       return <span className="greentext">+{numProfit.toFixed(2)}</span>;
//     } else {
//       return <span className="redtext">{numProfit.toFixed(2)}</span>;
//     }
//   };

//   // Pagination logic
//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= pageCount) {
//       setPage(newPage);
//     }
//   };

//   const start = (page - 1) * limit + 1;
//   const end = Math.min(page * limit, total);
//   const paginatedNotifications = notifications.slice(start - 1, end);

//   return (
//     <div
//       id="page-container"
//       className="page-header-fixed page-sidebar-fixed fade in"
//     >
//       <div id="content">
//         {loading && <LoadingSpinner />}
//         <div className="row pb-2">
//           <div className="col-md-6">
//             <ul className="breadcrumb">
//               <li className="breadcrumb-item">
//                 <a href="/dashboard">
//                   <i className="ti ti-home"></i> Home
//                 </a>
//               </li>
//               <li className="breadcrumb-item active">Manage Notification</li>
//             </ul>
//           </div>
//           <div className="col-md-6" style={{ textAlign: "right" }}>
//             <div className="d-flex flex-row-reverse gap-1">
//               <PermissionWrapper module="notification" action="add">
//                 <button
//                   className="btn btn-default btn-sm pull-right"
//                   onClick={() => navigate("/research/notifications/add")}
//                 >
//                   <i className="ti ti-plus"></i> Add Notification
//                 </button>
//               </PermissionWrapper>
//               <Link
//                 className="btn btn-default btn-sm pull-right"
//                 target="_blank"
//                 onClick={handleGenerateResult}
//               >
//                 <i className="ti ti-share"></i> Generate Results
//               </Link>
//               <Link
//                 className="btn btn-default btn-sm pull-right"
//                 target="_blank"
//                 to="/research/performance/dailyshareviewresult"
//               >
//                 <i className="ti ti-search"></i> View Daily Result
//               </Link>
//             </div>
//           </div>
//         </div>

//         <div className="panel panel-default with-rounded-corner with-shadow">
//           <form onSubmit={handleSubmit} className="stdform">
//             <div className="panel-heading border-0 d-flex justify-content-between align-items-center">
//               <span className="panel-title">Search Notification</span>

//               <div className="d-flex align-items-center">
//                 {/* Download button always on right side */}
//                 <button
//                   className="btn btn-default btn-sm"
//                   id="downloadBtn"
//                   type="button"
//                   onClick={handleDownloadResult}
//                 >
//                   <i className="ti ti-download"></i> Download Result
//                 </button>
//                 {/* Pagination controls (only if notifications available) */}
//                 {notifications.length > 0 && (
//                   <div className="me-3 text-right ms-2">
//                     <span style={{ fontSize: "0.8rem" }} className="me-2">
//                       {start} to {end} of {total}
//                     </span>
//                     <button
//                       className="btn btn-default btn-sm"
//                       title="Previous"
//                       onClick={() => handlePageChange(page - 1)}
//                       disabled={page === 1}
//                     >
//                       &lt;
//                     </button>
//                     &nbsp;
//                     <button
//                       className="btn btn-default btn-sm"
//                       title="Next"
//                       onClick={() => handlePageChange(page + 1)}
//                       disabled={page === pageCount}
//                     >
//                       &gt;
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="panel-body">
//               <div className="row">
//                 <div className="col-md-3">
//                   <label htmlFor="">Service</label>
//                   <StateManagedSelect
//                     options={serviceOptions}
//                     placeholder="Select Service"
//                     isMulti
//                     isSearchable
//                     value={serviceOptions.filter((option) =>
//                       serviceid.includes(option.value)
//                     )}
//                     onChange={handleSelectChange}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                     }}
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <InputBox
//                     label="Symbol"
//                     fieldname="symbol_name"
//                     placeholder="Enter Symbol"
//                     value={symbol_name}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label htmlFor="">Status</label>
//                   <StateManagedSelect
//                     options={statusOptions}
//                     placeholder="Select Status"
//                     isMulti
//                     value={statusOptions.filter((option) =>
//                       status.includes(option.value)
//                     )}
//                     onChange={handleSelectStatusChange}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                     }}
//                   />
//                 </div>
//                 <div className="col-md-3" style={{ marginTop: "25px" }}>
//                   <button type="submit" className="btn btn-primary">
//                     Submit
//                   </button>
//                   {(serviceid.length > 0 ||
//                     symbol_name !== "" ||
//                     status.length > 0) && (
//                     <button
//                       type="button"
//                       onClick={clearAll}
//                       className="btn btn-danger"
//                       style={{ marginLeft: "10px" }}
//                       title="Clear all filters"
//                     >
//                       Clear All
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>

//         {/* Pagination Controls */}
//         {/* {notifications.length > 0 && (
//           <div className="panel panel-default with-rounded-corner with-shadow p-10 mb-3">
//             <div className="panel-body text-right">
//               <span style={{ fontSize: "0.8rem" }} className="me-2">
//                 {start} to {end} of {total}
//               </span>
//               <button
//                 className="btn btn-default btn-sm"
//                 title="Previous"
//                 onClick={() => handlePageChange(page - 1)}
//                 disabled={page === 1}
//               >
//                 &lt;
//               </button>
//               &nbsp;
//               <button
//                 className="btn btn-default btn-sm"
//                 title="Next"
//                 onClick={() => handlePageChange(page + 1)}
//                 disabled={page === pageCount}
//               >
//                 &gt;
//               </button>
//             </div>
//           </div>
//         )} */}
//         <PermissionWrapper module="notification" action="view">
//           <div className="table-responsive panel panel-default with-rounded-corner with-shadow p-20 tbl_head_sticky">
//             <table className="table">
//                 <thead>
//                   <tr>
//                     <th style={{ textAlign: "center" }}>#</th>
//                     <th>Service</th>
//                     <th>Symbol</th>
//                     <th>Action</th>
//                     <th>Qty</th>
//                     <th>Entry <br /> Price</th>
//                     <th>Target <br /> Price</th>
//                     <th>Target <br /> Price</th>
//                     <th>Stop <br /> Loss</th>
//                     <th>CMP</th>
//                     <th>Status</th>
//                     <th style={{ minWidth: "290px" }}>Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paginatedNotifications.length ? (
//                     paginatedNotifications.map((post, index) => {
//                       const profitItem = profitLoss.find(
//                         (item) => item.id === post.id
//                       );
//                       const profit = profitItem ? profitItem.profit : "0.00";

//                       return (
//                         <React.Fragment key={post.id}>
//                           <tr className="remove-bottom">
//                             <td
//                               style={{
//                                 textAlign: "center",
//                                 verticalAlign: "middle",
//                               }}
//                             >
//                               {start + index}
//                             </td>
//                             <td>{post.service_name}</td>
//                             <td>{post.symbol}</td>
//                             <td>{post.action === 1 ? "Buy" : "Sell"}</td>
//                             <td>{post.quantity}</td>
//                             <td>{post.entry_price}</td>
//                             <td>{post.target_price}</td>
//                             <td>{post.target2_price}</td>
//                             <td>{post.stoploss}</td>
//                             <td className={`cmp_${post.instrument_token}`}>
//                               {post.cmp_price}
//                             </td>
//                             <td>
//                               {post.status == 0 && (
//                                 <label className="label label-warning btn-sm m-b-3">
//                                   Entry Awaited
//                                 </label>
//                               )}
//                               {post.status == 1 && (
//                                 <label className="label label-primary btn-sm m-b-3">
//                                   Active
//                                 </label>
//                               )}
//                               {post.status == 2 && (
//                                 <label className="label light-green btn-sm m-b-3">
//                                   Target 1 Hit
//                                 </label>
//                               )}
//                               {post.status == 3 && (
//                                 <label className="label dark-green btn-sm m-b-3">
//                                   Target 2 Hit
//                                 </label>
//                               )}
//                               {post.status == 4 && (
//                                 <label className="label red btn-sm m-b-3">
//                                   Stoploss Hit
//                                 </label>
//                               )}
//                               {post.status == 5 && (
//                                 <label className="label light-black btn-sm m-b-3">
//                                   Closed
//                                 </label>
//                               )}
//                               {post.status == 6 && (
//                                 <label className="label label-warning btn-sm m-b-3">
//                                   Entry Not Executed
//                                 </label>
//                               )}
//                             </td>
//                             <td>
//                               {(() => {
//                                 const date = new Date(post.created_on);
//                                 const day = String(date.getDate()).padStart(2, "0");
//                                 const month = String(date.getMonth() + 1).padStart(2, "0");
//                                 const year = date.getFullYear();
//                                 const minutes = String(date.getMinutes()).padStart(2, "0");
//                                 const ampm = date.getHours() >= 12 ? "PM" : "AM";
//                                 const hours12 = String(date.getHours() % 12 || 12).padStart(2, "0");
//                                 return `${day}-${month}-${year} ${hours12}:${minutes} ${ampm}`;
//                               })()}{" "}
//                               - By {post.created_by_name || post.user_fullname || "User"}{" "}
//                               {post.update_comment ? (
//                                 <>
//                                   <br />
//                                   <span className="light-black p-2">
//                                     {post.update_comment}
//                                   </span>
//                                 </>
//                               ) : (
//                                 ""
//                               )}
//                               {post.research_file && (
//                                 <>
//                                   {hasPermission("notification", "edit") && (
//                                     <a
//                                       href={`${API_URL}notification/share/${post.id}`}
//                                       className="btn btn-primary btn-xs ms-1"
//                                       style={{ float: "right" }}
//                                       data-toggle="tooltip"
//                                       data-placement="bottom"
//                                       title="Telegram Share"
//                                     >
//                                       <i className="ti ti-export"></i>
//                                     </a>
//                                   )}
//                                   <a
//                                     href={`${API_URL}uploads/research/${post.research_file}`}
//                                     className="btn btn-danger btn-xs ms-1"
//                                     style={{ float: "right" }}
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Download PDF"
//                                   >
//                                     <i className="ti ti-import"></i>
//                                   </a>
//                                 </>
//                               )}
//                             </td>
//                           </tr>
//                           <tr className="tagetinput">
//                             <td
//                               colSpan="6"
//                               style={{ borderTop: "0px", textAlign: "right" }}
//                             >
//                               &nbsp;
//                             </td>
//                             <td colSpan="1" style={{ borderTop: "0" }}>
//                               <input
//                                 type="text"
//                                 name="target_price"
//                                 style={{ width: "90px" }}
//                                 className={`form-control ${
//                                   editableIndex == start + index - 1
//                                     ? "d-block"
//                                     : "d-none"
//                                 }`}
//                                 value={editedData.target_price}
//                                 onChange={handleInputChange}
//                               />
//                             </td>
//                             <td colSpan="1" style={{ borderTop: "0px" }}>
//                               <input
//                                 type="text"
//                                 name="target2_price"
//                                 style={{ width: "90px" }}
//                                 className={`form-control ${
//                                   editableIndex == start + index - 1
//                                     ? "d-block"
//                                     : "d-none"
//                                 }`}
//                                 value={editedData.target2_price}
//                                 onChange={handleInputChange}
//                               />
//                             </td>
//                             <td colSpan="2" style={{ borderTop: "0px" }}>
//                               <input
//                                 type="text"
//                                 name="stoploss"
//                                 style={{ width: "90px" }}
//                                 className={`form-control ${
//                                   editableIndex == start + index - 1
//                                     ? "d-block"
//                                     : "d-none"
//                                 }`}
//                                 value={editedData.stoploss}
//                                 onChange={handleInputChange}
//                               />
//                             </td>
//                             <td className={`pl_${post.instrument_token}`}>
//                               {formatProfitLoss(profit)}
//                             </td>
//                             <td style={{ borderTop: "0px" }}>
//                               <div className="d-flex flex-row-reverse gap-1">
//                                 {/* <button
//                                   type="button"
//                                   className="btn btn-danger btn-xs mr-1"
//                                   style={{ float: "left" }}
//                                   data-toggle="tooltip"
//                                   title="Download PDF"
//                                   // onClick={() => handleDownloadResearchCall(post.id)}
//                                   disabled={loading}
//                                 >
//                                   <i className="ti ti-import"></i>
//                                 </button>
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary btn-xs mr-1"
//                                   style={{ float: "left" }}
//                                   data-toggle="tooltip"
//                                   title="Telegram Share"
//                                   // onClick={() => handleTelegramShare(post.id)}
//                                   disabled={loading}
//                                 >
//                                   <i className="ti ti-export"></i>
//                                 </button> */}
//                                 <PermissionWrapper
//                                   module="notification"
//                                   action="delete"
//                                 >
//                                   <button
//                                     onClick={() => handleDelete(post.id)}
//                                     className="cancel1 btn btn-danger btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Delete"
//                                   >
//                                     <i className="ti ti-trash"></i>
//                                   </button>
//                                 </PermissionWrapper>
//                                 <PermissionWrapper
//                                   module="notification"
//                                   action="edit"
//                                 >
//                                   <button
//                                     className="openPopup btn light-black btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Closed"
//                                     onClick={(e) =>
//                                       handleCloseNotification(e, post.id)
//                                     }
//                                   >
//                                     <i className="ti ti-close"></i>
//                                   </button>
//                                   <button
//                                     className="btn red btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Stoploss Hit"
//                                     onClick={(e) =>
//                                       handleStatusUpdate(e, post.id, 4)
//                                     }
//                                   >
//                                     <i className="ti ti-thumb-down"></i>
//                                   </button>
//                                   <button
//                                     className="btn dark-green btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Target 2 Hit"
//                                     onClick={(e) =>
//                                       handleStatusUpdate(e, post.id, 3)
//                                     }
//                                   >
//                                     <i className="ti ti-thumb-up"></i>
//                                   </button>
//                                   <button
//                                     className="btn light-green btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Target1 Hit"
//                                     onClick={(e) =>
//                                       handleStatusUpdate(e, post.id, 2)
//                                     }
//                                   >
//                                     <i className="ti ti-thumb-up"></i>
//                                   </button>
//                                 </PermissionWrapper>
//                                 {post.status !== 1 && (
//                                   <PermissionWrapper
//                                     module="notification"
//                                     action="edit"
//                                   >
//                                     <button
//                                       className="btn btn-primary btn-xs"
//                                       data-toggle="tooltip"
//                                       data-placement="bottom"
//                                       title="Update Performance"
//                                       onClick={(e) =>
//                                         handleUpdatePerformance(e, post.id)
//                                       }
//                                     >
//                                       <i className="ti ti-export"></i>
//                                     </button>
//                                   </PermissionWrapper>
//                                 )}
//                                 <PermissionWrapper
//                                   module="notification"
//                                   action="edit"
//                                 >
//                                   <Link
//                                     to={`/research/notifications/edit/${post.id}`}
//                                     className="btn btn-warning btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Edit"
//                                   >
//                                     <i className="ti ti-pencil"></i>
//                                   </Link>
//                                   <button
//                                     onClick={() =>
//                                       toggleEdit(start + index - 1)
//                                     }
//                                     className="btn btn-primary btn-xs edit-on-page"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Edit On Page"
//                                   >
//                                     <i className="ti ti-pencil"></i>
//                                   </button>
//                                 </PermissionWrapper>
//                                 <PermissionWrapper
//                                   module="notification"
//                                   action="edit"
//                                 >
//                                   <button
//                                     className="openComment btn yellow btn-xs"
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Comment"
//                                     onClick={() => handleCommentUpdate(post.id)}
//                                   >
//                                     <i className="ti ti-comment"></i>
//                                   </button>
//                                 </PermissionWrapper>
//                                 {post.status > 1 && (
//                                   <PermissionWrapper
//                                     module="notification"
//                                     action="edit"
//                                   >
//                                     <button
//                                       className="reactivebtn btn light-black btn-xs"
//                                       data-toggle="tooltip"
//                                       data-placement="bottom"
//                                       title="Reactivation"
//                                       onClick={(e) =>
//                                         handleReactivation(e, post.id)
//                                       }
//                                     >
//                                       <i className="ti ti-reload"></i>
//                                     </button>
//                                   </PermissionWrapper>
//                                 )}
//                                 <PermissionWrapper
//                                   module="notification"
//                                   action="edit"
//                                 >
//                                   <button
//                                     className={`btn btn-primary btn-xs ${
//                                       editableIndex === start + index - 1
//                                         ? ""
//                                         : "d-none"
//                                     }`}
//                                     data-toggle="tooltip"
//                                     data-placement="bottom"
//                                     title="Save"
//                                     onClick={() => handleSave(post.id)}
//                                   >
//                                     <i className="ti ti-save"></i>
//                                   </button>
//                                 </PermissionWrapper>
//                               </div>
//                               <span
//                                 style={{
//                                   fontSize: "10px",
//                                   letterSpacing: "0.5px",
//                                   fontWeight: 500,
//                                 }}
//                               >
//                                 {post.duration}
//                               </span>
//                             </td>
//                           </tr>
//                         </React.Fragment>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan="12" className="noRecord">
//                         No Records Found..
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//           </div>
//         </PermissionWrapper>
//       </div>
//     </div>
//   );
// };

// export default Notifications;



import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { InputBox } from "../../components/Input";
import "./Notificaions.css";
import { API_URL } from "../../config";
import axios from "axios";
import StateManagedSelect from "react-select";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import { PermissionWrapper, hasPermission } from "../../helpers/permission.js";
import usePersistedState from "../../Subscriber/usePersistedState.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import CareparvaResponseModal from "./CareparvaResponseModal.jsx";

const Notifications = () => {
  const navigate = useNavigate();
  // Persisted filter states (like Order page)
  const [serviceid, setServiceid] = usePersistedState(
    "notifications_serviceid",
    []
  );
  const [symbol_name, setSymbolName] = usePersistedState(
    "notifications_symbol_name",
    ""
  );
  const [status, setStatus] = usePersistedState("notifications_status", []);

  const [notifications, setNotifications] = useState([]);
  const [serviceOptions, setserviceOptions] = useState([]);
  const [profitLoss, setProfitLoss] = useState([]);
  const [editableIndex, setEditableIndex] = useState(null);
  const [editedData, setEditedData] = useState({
    target_price: "",
    target2_price: "",
    stoploss: "",
  });
  const [loading, setLoading] = useState(false);
  const [generateResultLoading, setGenerateResultLoading] = useState(false);
  const [downloadResultLoading, setDownloadResultLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtersReset, setFiltersReset] = useState(false);
  const [livePrices, setLivePrices] = useState({});
  const token = localStorage.getItem("authToken");

  // Pagination states
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 100;

  // Careparva Response Modal state
  const [selectedCareparvaNotification, setSelectedCareparvaNotification] = useState(null);
  const [careparvaModalType, setCareparvaModalType] = useState("create");
  const [isCareparvaModalOpen, setIsCareparvaModalOpen] = useState(false);

  const handleOpenCareparvaModal = (notification, type = "create") => {
    setSelectedCareparvaNotification(notification);
    setCareparvaModalType(type);
    setIsCareparvaModalOpen(true);
  };

  // WebSocket connection for live price updates
  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_WS_URL);

    ws.onopen = () => {
      console.log("WebSocket connected");
    };

    ws.onmessage = (event) => {
      try {
        const messages = JSON.parse(event.data);
        setLivePrices((prev) => ({
          ...prev,
          [messages.instrument_token]: messages.last_price,
        }));
        console.log("WebSocket message received:", messages);
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed");
    };

    return () => {
      ws.close();
    };
  }, []);

  // Update CMP prices when live prices change
  useEffect(() => {
    const updatedNotifications = notifications.map((notification) => {
      const livePrice = livePrices[notification.instrument_token];
      if (livePrice !== undefined) {
        return {
          ...notification,
          cmp_price: livePrice,
        };
      }
      return notification;
    });

    setNotifications(updatedNotifications);
  }, [livePrices]);

  // Calculate profit/loss in real-time
  useEffect(() => {
    const calculateProfitLoss = () => {
      const newProfitLoss = notifications.map((notification) => {
        const ep = parseFloat(notification.entry_price) || 0;
        const cp = parseFloat(notification.cmp_price) || 0;
        const qty = parseFloat(notification.quantity) || 0;
        const buyact = parseInt(notification.action);
        const status = parseInt(notification.status);
        const gainsnew = parseFloat(notification.gains) || 0;

        let profit = 0;

        if (status === 1) {
          // Only calculate for active notifications
          if (buyact === 1) {
            profit = (cp - ep) * qty;
          } else if (buyact === 2) {
            profit = (ep - cp) * qty;
          }
        } else {
          // For non-active statuses (0, 2, 3, 4, 5, 6), use gainsnew from backend
          profit = gainsnew;
        }

        return {
          ...notification,
          profit: profit.toFixed(2),
        };
      });

      setProfitLoss(newProfitLoss);
    };

    calculateProfitLoss();

    // Set up interval for continuous calculation (only affects active statuses)
    const intervalId = setInterval(calculateProfitLoss, 1000);

    return () => clearInterval(intervalId);
  }, [notifications]);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}service/active-services`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const formattedData = response.data.data.map((dt) => ({
        value: dt.id,
        label: dt.service_name,
      }));

      setserviceOptions(formattedData);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchNotification = async () => {
    let url = `${API_URL}notification/list?serviceid=${serviceid}&symbol=${symbol_name}`;
    if (status && status.length > 0) {
      // Join status array with commas and encode it
      const encodedStatus = encodeURIComponent(status.join(","));
      url += `&status=${encodedStatus}`;
    }

    try {
      setLoading(true);
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const notificationsData = response.data?.data?.data || [];
      console.log("Fetched Notifications:", response);
      setNotifications(notificationsData);
      setTotal(notificationsData.length);
      setPageCount(Math.ceil(notificationsData.length / limit));
      setPage(1); // Reset to first page when data changes
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotification();
    fetchServices();
  }, []);

  useEffect(() => {
    const refreshed = sessionStorage.getItem("page_refreshed");
    if (!refreshed) {
      sessionStorage.setItem("page_refreshed", "true");
      window.location.reload();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "symbol_name") setSymbolName(value);
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setServiceid(selectedValues);
  };

  const handleSelectStatusChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setStatus(selectedValues);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchNotification();
  };

  const clearAll = () => {
    setServiceid([]);
    setSymbolName("");
    setStatus([]);
    try {
      localStorage.removeItem("notifications_serviceid");
      localStorage.removeItem("notifications_symbol_name");
      localStorage.removeItem("notifications_status");
    } catch (_) { }
    setFiltersReset(true);
  };

  useEffect(() => {
    if (filtersReset) {
      fetchNotification();
      setFiltersReset(false);
    }
  }, [filtersReset]);

  useEffect(() => {
    const handleClearFilters = () => {
      clearAll();
    };

    window.addEventListener('clearResearchNotificationsFiltersEvent', handleClearFilters);

    return () => {
      window.removeEventListener('clearResearchNotificationsFiltersEvent', handleClearFilters);
    };
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-danger",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        const response = await axios.delete(
          `${API_URL}notification/${id}/delete`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setNotifications((prev) => prev.filter((dt) => dt.id !== id));
        Swal.fire(
          "Deleted!",
          response.data.message || "Your record has been deleted.",
          "success"
        );
        fetchNotification(); // Refresh data after deletion
      } catch (error) {
        Swal.fire(
          "Error",
          error.response?.data?.message ||
          "Something went wrong while deleting.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const statusOptions = [
    { value: "", label: "Select Status" },
    { value: "0", label: "InActive" },
    { value: "1", label: "Active" },
    { value: "2", label: "Target 1" },
    { value: "3", label: "Target 2" },
    { value: "4", label: "Stoploss" },
    { value: "5", label: "Closed" },
  ];

  const toggleEdit = (index) => {
    setEditableIndex(index === editableIndex ? null : index);
    const post = notifications[index];
    setEditedData({
      target_price: post.target_price || "",
      target2_price: post.target2_price || "",
      stoploss: post.stoploss || "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (id) => {
    const payload = {
      intgt1: parseFloat(editedData.target_price),
      intgt2: parseFloat(editedData.target2_price),
      insl: parseFloat(editedData.stoploss),
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}notification/save-on-page?id=${id}&notifyme=true`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        setEditableIndex(null);
        fetchNotification();
        showToast.success("Notification updated successfully");
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (e, id, status) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.patch(
        `${API_URL}notification/${id}/status?status=${status}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        showToast.success("Notification Status Changed Successfully");
        fetchNotification();
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseNotification = async (e, id) => {
    const { value: inputValue, isConfirmed } = await Swal.fire({
      title: "Reason",
      input: "text",
      inputLabel: "Enter Reason For Closing?",
      inputPlaceholder: "Enter Reason",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to write something!";
        }
      },
    });

    if (isConfirmed && inputValue) {
      try {
        setLoading(true);
        const response = await axios.put(
          `${API_URL}notification/${id}/close`,
          {
            description: inputValue,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          showToast.success("Notification Status Updated Successfully");
          fetchNotification();
        }
      } catch (error) {
        console.error("Error saving notification:", error);
        showToast.error("There was an error saving the notification");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleUpdatePerformance = async (e, id) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.patch(
        `${API_URL}notification/${id}/performance`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        showToast.success("Notification Updated Successfully");
        fetchNotification();
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    } finally {
      setLoading(false);
    }
  };

  const handleCommentUpdate = async (id) => {
    const { value: inputValue, isConfirmed } = await Swal.fire({
      title: "Comments",
      input: "text",
      inputLabel: "Enter Comments For User",
      inputPlaceholder: "Enter Comments",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to write something!";
        }
      },
    });

    if (isConfirmed && inputValue) {
      try {
        setLoading(true);
        const response = await axios.post(
          `${API_URL}notification/send-comment/${id}`,
          {
            commentDescription: inputValue,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.success == true) {
          showToast.success("Comment Updated.");
          fetchNotification();
        }
      } catch (error) {
        showToast.error(
          error.response?.data?.message ||
          "Something went wrong while submitting."
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleGenerateResult = async (e) => {
    e.preventDefault();
    try {
      setGenerateResultLoading(true);
      let params = [];
      if (serviceid && serviceid.length) params.push(`serviceid=${serviceid}`);
      if (symbol_name) params.push(`symbol=${symbol_name}`);
      params.push(`status=${status.join(",")}`);

      const queryString = params.length ? `?${params.join("&")}` : "";

      const response = await axios.get(
        `${API_URL}notification/generateResult${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        showToast.success("Performance Result Generated Successfully");
      }
    } catch (error) {
      showToast.error(
        error.response?.data?.message ||
        "Something went wrong while downloading."
      );
    } finally {
      setGenerateResultLoading(false);
    }
  };

  const handleDownloadResult = async (e) => {
    e.preventDefault();
    try {
      setDownloadResultLoading(true);
      let params = [];
      if (serviceid && serviceid.length) params.push(`serviceid=${serviceid}`);
      if (symbol_name) params.push(`symbol=${symbol_name}`);
      params.push(`status=${status.join(",")}`);
      const queryString = params.length ? `?${params.join("&")}` : "";

      const response = await axios.get(
        `${API_URL}notification/resultLive${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "daily-result.png");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        showToast.success("Result Downloaded Successfully");
      }
    } catch (error) {
      showToast.error(
        error.response?.data?.message ||
        "Something went wrong while submitting."
      );
    } finally {
      setDownloadResultLoading(false);
    }
  };

  const handleReactivation = async (e, id) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to reactive this notification!",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Reactivate it!",
      cancelButtonText: "No, cancel!",
      confirmButtonClass: "btn-success",
      cancelButtonClass: "btn-danger",
    });

    if (result.isConfirmed) {
      await handleStatusUpdate(e, id, 1);
    }
  };

  // Helper function to format profit/loss display
  const formatProfitLoss = (profit) => {
    const numProfit = parseFloat(profit);
    if (numProfit >= 0) {
      return <span className="greentext">+{numProfit.toFixed(2)}</span>;
    } else {
      return <span className="redtext">{numProfit.toFixed(2)}</span>;
    }
  };

  // Pagination logic
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pageCount) {
      setPage(newPage);
    }
  };

  const handleShare = async (id) => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${API_URL}notification/${id}/notification-share`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success || response.status === 201) {
        showToast.success("Shared successfully");
        // navigate("/research/performance/shareview");
      } else {
        showToast.error(response.data.message || "Failed to share");
      }
    } catch (err) {
      console.error("Share failed", err);
      showToast.error(err.response?.data?.message || "Failed to share");
    } finally {
      setLoading(false);
    }
  };


  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  const paginatedNotifications = notifications.slice(start - 1, end);

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content">
        <div className="row pb-2">
          <div className="col-md-6 col-sm-6">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/dashboard">
                  <i className="ti ti-home"></i> Home
                </a>
              </li>
              <li className="breadcrumb-item active">Manage Notification</li>
            </ul>
          </div>
          <div className="col-md-6" style={{ textAlign: "right" }}>
            <div className="d-flex flex-row-reverse gap-1">
              <PermissionWrapper module="notification" action="add">
                <button
                  className="btn btn-default btn-sm pull-right"
                  onClick={() => navigate("/research/notifications/add")}
                >
                  <i className="ti ti-plus"></i> Add Notification
                </button>
              </PermissionWrapper>
              <button
                type="button"
                className="btn btn-default btn-sm pull-right"
                onClick={handleGenerateResult}
                disabled={generateResultLoading}
              >
                {generateResultLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Generating...
                  </>
                ) : (
                  <>
                    <i className="ti ti-share"></i> Generate Results
                  </>
                )}
              </button>
              <Link
                className="btn btn-default btn-sm pull-right"
                target="_blank"
                to="/research/performance/dailyshareviewresult"
              >
                <i className="ti ti-search"></i> View Daily Result
              </Link>
            </div>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <div className="panel-heading border-0 d-flex justify-content-between align-items-center">
              <span className="panel-title">Search Notification</span>

              <div className="d-flex align-items-center">
                {/* Download button always on right side */}
                <button
                  className="btn btn-default btn-sm"
                  id="downloadBtn"
                  type="button"
                  onClick={handleDownloadResult}
                  disabled={downloadResultLoading}
                >
                  {downloadResultLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Downloading...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-download"></i> Download Result
                    </>
                  )}
                </button>
                {/* Pagination controls (only if notifications available) */}
                {notifications.length > 0 && (
                  <div className="me-3 text-right ms-2">
                    <span style={{ fontSize: "0.8rem" }} className="me-2">
                      {start} to {end} of {total}
                    </span>
                    <button
                      className="btn btn-default btn-sm"
                      title="Previous"
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                    >
                      &lt;
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-default btn-sm"
                      title="Next"
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === pageCount}
                    >
                      &gt;
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="panel-body">
              <div className="row">
                <div className="col-md-3">
                  <label htmlFor="">Service</label>
                  <StateManagedSelect
                    options={serviceOptions}
                    placeholder="Select Service"
                    isMulti
                    isSearchable
                    value={serviceOptions.filter((option) =>
                      serviceid.includes(option.value)
                    )}
                    onChange={handleSelectChange}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <InputBox
                    label="Symbol"
                    fieldname="symbol_name"
                    placeholder="Enter Symbol"
                    value={symbol_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="">Status</label>
                  <StateManagedSelect
                    options={statusOptions}
                    placeholder="Select Status"
                    isMulti
                    value={statusOptions.filter((option) =>
                      status.includes(option.value)
                    )}
                    onChange={handleSelectStatusChange}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <div className="col-md-3" style={{ marginTop: "25px" }}>
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  {(serviceid.length > 0 ||
                    symbol_name !== "" ||
                    status.length > 0) && (
                      <button
                        type="button"
                        onClick={clearAll}
                        className="btn btn-danger"
                        style={{ marginLeft: "10px" }}
                        title="Clear all filters"
                      >
                        Clear All
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>

        <PermissionWrapper module="notification" action="view">
          <div className="table-responsive panel panel-default with-rounded-corner with-shadow p-20 tbl_head_sticky">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th>Service</th>
                  <th>Symbol</th>
                  <th>Action</th>
                  <th>Qty</th>
                  <th>Entry <br /> Price</th>
                  <th>Target <br /> Price</th>
                  <th>Target <br /> Price</th>
                  <th>Stop <br /> Loss</th>
                  <th>CMP</th>
                  <th>Status</th>
                  <th style={{ minWidth: "290px" }}>Date</th>
                </tr>
              </thead>
              <tbody>
                <style>
                  {`
                  .skeleton-text {
                    height: 12px;
                    background: #ececec;
                    background-image: linear-gradient(
                      to right,
                      #ececec 0%,
                      #f4f4f4 20%,
                      #ececec 40%,
                      #ececec 100%
                    );
                    background-repeat: no-repeat;
                    background-size: 800px 100%;
                    display: inline-block;
                    position: relative;
                    animation: skeleton-animation 1.2s ease-in-out infinite;
                    border-radius: 4px;
                  }

                  @keyframes skeleton-animation {
                    0% {
                      background-position: -400px 0;
                    }
                    100% {
                      background-position: 400px 0;
                    }
                  }
                `}
                </style>
                {loading ? (
                  /* Skeleton loading rows */
                  Array.from({ length: 10 }).map((_, skeletonIndex) => (
                    <tr key={`skeleton-${skeletonIndex}`}>
                      {Array.from({ length: 13 }).map((_, colIndex) => (
                        <td
                          key={colIndex}
                          style={{ textAlign: colIndex === 0 ? "center" : "left" }}
                        >
                          <div
                            className="skeleton-text"
                            style={{
                              width: colIndex === 0 ? "30%" : "80%",
                              margin: colIndex === 0 ? "0 auto" : "0",
                            }}
                          ></div>
                        </td>
                      ))}
                    </tr>
                  ))
                ) : paginatedNotifications.length ? (
                  paginatedNotifications.map((post, index) => {
                    const profitItem = profitLoss.find(
                      (item) => item.id === post.id
                    );
                    const profit = profitItem ? profitItem.profit : "0.00";

                    return (
                      <React.Fragment key={post.id}>
                        <tr className="remove-bottom">
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {start + index}
                          </td>
                          <td>
                            <div>{post.service_name}</div>
                            {post.unique_id && (
                              <span style={{ fontSize: "11px", color: "#888", display: "block", marginTop: "2px" }}>
                                ID: {post.unique_id}
                              </span>
                            )}
                          </td>
                          <td>{post.symbol}</td>
                          <td>{post.action === 1 ? "Buy" : "Sell"}</td>
                          <td>{post.quantity}</td>
                          <td>{post.entry_price}</td>
                          <td>{post.target_price}</td>
                          <td>{post.target2_price}</td>
                          <td>{post.stoploss}</td>
                          <td className={`cmp_${post.instrument_token}`}>
                            {post.cmp_price}
                          </td>
                          <td>
                            {post.status == 0 && (
                              <label className="label label-warning btn-sm m-b-3">
                                Entry Awaited
                              </label>
                            )}
                            {post.status == 1 && (
                              <label className="label label-primary btn-sm m-b-3">
                                Active
                              </label>
                            )}
                            {post.status == 2 && (
                              <label className="label light-green btn-sm m-b-3">
                                Target 1 Hit
                              </label>
                            )}
                            {post.status == 3 && (
                              <label className="label dark-green btn-sm m-b-3">
                                Target 2 Hit
                              </label>
                            )}
                            {post.status == 4 && (
                              <label className="label red btn-sm m-b-3">
                                Stoploss Hit
                              </label>
                            )}
                            {post.status == 5 && (
                              <label className="label light-black btn-sm m-b-3">
                                Closed
                              </label>
                            )}
                            {post.status == 6 && (
                              <label className="label label-warning btn-sm m-b-3">
                                Entry Not Executed
                              </label>
                            )}
                          </td>
                          <td>
                            {(() => {
                              const date = new Date(post.created_on);
                              const day = String(date.getDate()).padStart(2, "0");
                              const month = String(date.getMonth() + 1).padStart(2, "0");
                              const year = date.getFullYear();
                              const minutes = String(date.getMinutes()).padStart(2, "0");
                              const ampm = date.getHours() >= 12 ? "PM" : "AM";
                              const hours12 = String(date.getHours() % 12 || 12).padStart(2, "0");
                              return `${day}-${month}-${year} ${hours12}:${minutes} ${ampm}`;
                            })()}{" "}
                            - By {post.created_by_name || post.user_fullname || "User"}{" "}
                            {post.update_comment ? (
                              <>
                                <br />
                                <span className="light-black p-2">
                                  {post.update_comment}
                                </span>
                              </>
                            ) : (
                              ""
                            )}
                            {post.research_file && (
                              <>
                                {hasPermission("notification", "edit") && (
                                  <button
                                    onClick={() => handleShare(post.id)}
                                    className="btn btn-primary btn-xs ms-1"
                                    style={{ float: "right" }}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Telegram Share"
                                  >
                                    <i className="ti ti-export"></i>
                                  </button>
                                )}
                                {/* <a
                                  href={`${API_URL}uploads/research/${post.research_file}`}
                                  className="btn btn-danger btn-xs ms-1"
                                  style={{ float: "right" }}
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Download PDF"
                                >
                                  <i className="ti ti-import"></i>
                                </a> */}
                                <a
                                  href={post.research_file}
                                  className="btn btn-danger btn-xs ms-1"
                                  style={{ float: "right" }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Download PDF"
                                >
                                  <i className="ti ti-import"></i>
                                </a>
                              </>
                            )}
                          </td>
                        </tr>
                        <tr className="tagetinput">
                          <td>&nbsp;</td>
                          <td>
                                                        <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                              {/* 1st Check Button: Create Advice */}
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenCareparvaModal(post, "create");
                                }}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "6px",
                                  border: `1px solid ${
                                    post.parva_create === 2
                                      ? "#fca5a5"
                                      : post.parva_create === 1
                                      ? "#86efac"
                                      : "#e2e8f0"
                                  }`,
                                  background:
                                    post.parva_create === 2
                                      ? "#fef2f2"
                                      : post.parva_create === 1
                                      ? "#f0fdf4"
                                      : "#f8fafc",
                                  cursor: "pointer",
                                  padding: 0,
                                  transition: "all 0.15s ease",
                                }}
                                title="Create"
                              >
                                {post.parva_create === 1 ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{ color: "#16a34a", fontSize: "13px" }}
                                  />
                                ) : post.parva_create === 2 ? (
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    style={{ color: "#dc2626", fontSize: "14px", fontWeight: "bold" }}
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{ color: "#cbd5e1", fontSize: "13px" }}
                                  />
                                )}
                              </button>

                              {/* 2nd Check Button: Update Advice */}
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenCareparvaModal(post, "update");
                                }}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "6px",
                                  border: `1px solid ${
                                    post.parva_update === 2
                                      ? "#fca5a5"
                                      : post.parva_update === 1 || post.parva_update > 0
                                      ? "#86efac"
                                      : "#e2e8f0"
                                  }`,
                                  background:
                                    post.parva_update === 2
                                      ? "#fef2f2"
                                      : post.parva_update === 1 || post.parva_update > 0
                                      ? "#f0fdf4"
                                      : "#f8fafc",
                                  cursor: "pointer",
                                  padding: 0,
                                  transition: "all 0.15s ease",
                                }}
                                title="Update"
                              >
                                {post.parva_update === 1 || post.parva_update > 0 ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{ color: "#16a34a", fontSize: "13px" }}
                                  />
                                ) : post.parva_update === 2 ? (
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    style={{ color: "#dc2626", fontSize: "14px", fontWeight: "bold" }}
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{ color: "#cbd5e1", fontSize: "13px" }}
                                  />
                                )}
                              </button>
                            </div>

                          </td>
                          <td
                            colSpan="4"
                            style={{ borderTop: "0px", textAlign: "right" }}
                          >
                            &nbsp;
                          </td>
                          <td colSpan="1" style={{ borderTop: "0" }}>
                            <input
                              type="text"
                              name="target_price"
                              style={{ width: "90px" }}
                              className={`form-control ${editableIndex == start + index - 1
                                ? "d-block"
                                : "d-none"
                                }`}
                              value={editedData.target_price}
                              onChange={handleInputChange}
                            />
                          </td>
                          <td colSpan="1" style={{ borderTop: "0px" }}>
                            <input
                              type="text"
                              name="target2_price"
                              style={{ width: "90px" }}
                              className={`form-control ${editableIndex == start + index - 1
                                ? "d-block"
                                : "d-none"
                                }`}
                              value={editedData.target2_price}
                              onChange={handleInputChange}
                            />
                          </td>
                          <td colSpan="2" style={{ borderTop: "0px" }}>
                            <input
                              type="text"
                              name="stoploss"
                              style={{ width: "90px" }}
                              className={`form-control ${editableIndex == start + index - 1
                                ? "d-block"
                                : "d-none"
                                }`}
                              value={editedData.stoploss}
                              onChange={handleInputChange}
                            />
                          </td>
                          <td className={`pl_${post.instrument_token}`}>
                            {formatProfitLoss(profit)}
                          </td>
                          <td style={{ borderTop: "0px" }}>
                            <div className="d-flex align-items-center justify-content-between">
                              <span
                                style={{
                                  fontSize: "10px",
                                  letterSpacing: "0.5px",
                                  fontWeight: 500,
                                  marginRight: "5px",
                                }}
                              >
                                ({post.duration})
                              </span>
                              {/* <button
                                  type="button"
                                  className="btn btn-danger btn-xs mr-1"
                                  style={{ float: "left" }}
                                  data-toggle="tooltip"
                                  title="Download PDF"
                                  // onClick={() => handleDownloadResearchCall(post.id)}
                                  disabled={loading}
                                >
                                  <i className="ti ti-import"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary btn-xs mr-1"
                                  style={{ float: "left" }}
                                  data-toggle="tooltip"
                                  title="Telegram Share"
                                  // onClick={() => handleTelegramShare(post.id)}
                                  disabled={loading}
                                >
                                  <i className="ti ti-export"></i>
                                </button> */}
                              <div className="d-flex flex-row-reverse gap-1">
                                <PermissionWrapper
                                  module="notification"
                                  action="delete"
                                >
                                  <button
                                    onClick={() => handleDelete(post.id)}
                                    className="cancel1 btn btn-danger btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Delete"
                                  >
                                    <i className="ti ti-trash"></i>
                                  </button>
                                </PermissionWrapper>
                                <PermissionWrapper
                                  module="notification"
                                  action="edit"
                                >
                                  <button
                                    className="openPopup btn light-black btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Closed"
                                    onClick={(e) =>
                                      handleCloseNotification(e, post.id)
                                    }
                                  >
                                    <i className="ti ti-close"></i>
                                  </button>
                                  <button
                                    className="btn red btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Stoploss Hit"
                                    onClick={(e) =>
                                      handleStatusUpdate(e, post.id, 4)
                                    }
                                  >
                                    <i className="ti ti-thumb-down"></i>
                                  </button>
                                  <button
                                    className="btn dark-green btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Target 2 Hit"
                                    onClick={(e) =>
                                      handleStatusUpdate(e, post.id, 3)
                                    }
                                  >
                                    <i className="ti ti-thumb-up"></i>
                                  </button>
                                  <button
                                    className="btn light-green btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Target1 Hit"
                                    onClick={(e) =>
                                      handleStatusUpdate(e, post.id, 2)
                                    }
                                  >
                                    <i className="ti ti-thumb-up"></i>
                                  </button>
                                </PermissionWrapper>
                                {post.status !== 1 && (
                                  <PermissionWrapper
                                    module="notification"
                                    action="edit"
                                  >
                                    <button
                                      className="btn btn-primary btn-xs"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="Update Performance"
                                      onClick={(e) =>
                                        handleUpdatePerformance(e, post.id)
                                      }
                                    >
                                      <i className="ti ti-export"></i>
                                    </button>
                                  </PermissionWrapper>
                                )}
                                <PermissionWrapper
                                  module="notification"
                                  action="edit"
                                >
                                  <Link
                                    to={`/research/notifications/edit/${post.id}`}
                                    className="btn btn-warning btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Edit"
                                  >
                                    <i className="ti ti-pencil"></i>
                                  </Link>
                                  <button
                                    onClick={() =>
                                      toggleEdit(start + index - 1)
                                    }
                                    className="btn btn-primary btn-xs edit-on-page"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Edit On Page"
                                  >
                                    <i className="ti ti-pencil"></i>
                                  </button>
                                </PermissionWrapper>
                                <PermissionWrapper
                                  module="notification"
                                  action="edit"
                                >
                                  <button
                                    className="openComment btn yellow btn-xs"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Comment"
                                    onClick={() => handleCommentUpdate(post.id)}
                                  >
                                    <i className="ti ti-comment"></i>
                                  </button>
                                </PermissionWrapper>
                                {post.status > 1 && (
                                  <PermissionWrapper
                                    module="notification"
                                    action="edit"
                                  >
                                    <button
                                      className="reactivebtn btn light-black btn-xs"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="Reactivation"
                                      onClick={(e) =>
                                        handleReactivation(e, post.id)
                                      }
                                    >
                                      <i className="ti ti-reload"></i>
                                    </button>
                                  </PermissionWrapper>
                                )}
                                {/* Duration span moved here near Comment button */}
                                {/* <span
                                  style={{
                                    fontSize: "10px",
                                    letterSpacing: "0.5px",
                                    fontWeight: 500,
                                    marginLeft: "8px",
                                    alignSelf: "center"
                                  }}
                                >
                                  ({post.duration})
                                </span> */}
                                <button
                                  className={`btn btn-danger btn-xs ${editableIndex === start + index - 1
                                    ? ""
                                    : "d-none"
                                    }`}
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Close"
                                  onClick={() => setEditableIndex(null)}
                                >
                                  <i className="ti ti-close"></i>
                                </button>
                                <PermissionWrapper
                                  module="notification"
                                  action="edit"
                                >
                                  <button
                                    className={`btn btn-primary btn-xs ${editableIndex === start + index - 1
                                      ? ""
                                      : "d-none"
                                      }`}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Save"
                                    onClick={() => handleSave(post.id)}
                                  >
                                    <i className="ti ti-save"></i>
                                  </button>
                                </PermissionWrapper>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="13" className="noRecord">
                      No Records Found..
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </PermissionWrapper>

        {/* Careparva Response Modal */}
        <CareparvaResponseModal
          isOpen={isCareparvaModalOpen}
          onClose={() => setIsCareparvaModalOpen(false)}
          notification={selectedCareparvaNotification}
          modalType={careparvaModalType}
        />
      </div>
    </div>
  );
};

export default Notifications;